module.exports = __webpack_public_path__ + "static/media/oge2.png.96d636fa.jpg";